export default __webpack_public_path__ + "static/media/screen-logo.0f5ca791.svg";